import * as flowApi from "./task";
import * as flowCarApi from "./taskCar";
import * as definition from "./definition";

export default {
    flowApi,
    flowCarApi,
    definition
};